import { AxiosResponse } from 'axios';
import axios from '../api';
import { IPracticeCategory, IPracticeCategoryRow, IPracticeCategoryBody } from '../../helpers/interfaces/categories';
import { ICategoryAll } from '../../helpers/interfaces/practices';
import StorageService from '../../helpers/StorageService';

const API_URL = process.env.REACT_APP_API_URL;

class CategoriePraticheService {

    getPracticeCategories(nofilter: boolean = false): Promise<IPracticeCategory> {
        // recupero 
        const savedCommercial = StorageService.getItem<{ id: number, name: string }>('practiceForCommercial');

        const queryParams = new URLSearchParams();

        if (nofilter) {
            queryParams.append('nofilter', 'true');
        }

        if (typeof savedCommercial != "undefined" && savedCommercial != null) {
            queryParams.append('practiceForCommercial', savedCommercial.toString());
        }

        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        return axios.get<IPracticeCategory>(API_URL + 'practiceCategories' + queryString)
            .then((response: AxiosResponse<any>) => { return response.data.data; })
            .catch((error) => { return Promise.reject(error); });
    }

    getPracticeCategoriesAll(): Promise<ICategoryAll> {
        return axios.get<ICategoryAll>(API_URL + 'practiceCategories/all')
            .then((response: AxiosResponse<any>) => { return response.data.data; })
            .catch((error) => { return Promise.reject(error); });
    }

    getPracticeCategory(id: any): Promise<IPracticeCategoryRow> {
        return axios.get<IPracticeCategoryRow>(API_URL + 'practiceCategory/' + id)
            .then((response: AxiosResponse<any>) => { return response.data.data })
            .catch((error) => { return Promise.reject(error); });
    }

    addPracticeCategory(body: IPracticeCategoryBody): Promise<IPracticeCategoryRow> {
        return axios.post<IPracticeCategoryBody>(API_URL + 'practiceCategory', body)
            .then((response: AxiosResponse<any>) => { return response.data; })
            .catch((error) => { return Promise.reject(error); });
    }

    editPracticeCategory(id: any, body: IPracticeCategoryBody): Promise<IPracticeCategoryRow> {
        return axios.put<IPracticeCategoryBody>(API_URL + 'practiceCategory/' + id, body)
            .then((response: AxiosResponse<any>) => { return response.data; })
            .catch((error) => { return Promise.reject(error); });
    }

    deletePracticeCategory(id: any): Promise<any> {
        return axios.delete<any>(API_URL + 'practiceCategory/' + id)
            .then((response: AxiosResponse<any>) => { return response.data; })
            .catch((error) => { return Promise.reject(error); });
    }

}
export default new CategoriePraticheService();